const defaultSearchConfiguration = {
    _searchable: true,
    email: { _searchable: true, _score: 500 },
    attemptType: { _searchable: true, _score: 300 },
    conflictType: { _searchable: true, _score: 300 },
};

export default defaultSearchConfiguration;
